  <div class="row mb-2">
    <div class="col">
      <div class="materials-select-wrapper">
        <select #materialsListSelect class="form-select">
          <option [ngValue]="null" selected disabled>
            Изберете материал
          </option>
          <ng-container *ngFor="let m of _availableMaterialsList">
            <ng-container *ngIf="m.isActive">
              <option [value]="m.id">{{ m.title }}</option>
            </ng-container>
          </ng-container>
        </select>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="!materialsListSelect.value"
          (click)="onAddMaterialClicked(+materialsListSelect.value); materialsListSelect.selectedIndex = 0"
        >
          Добави
        </button>
      </div>
    </div>
  </div>
  <ng-container *ngIf="_usedEmergencyMaterialsList.length">
    <div class="row mb-3">
      <div class="col">
        <table class="table table-sm table-reset table-hover">
          <thead>
            <tr>
              <th scope="col">Име на материал</th>
              <th scope="col">Мерна единица</th>
              <th scope="col">Налично количество</th>
              <th scope="col" class="emergency-material-quantity-input-col">Нужна бройка</th>
              <th scope="col" class="edit-action-col">Редакция</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let em of _usedEmergencyMaterialsList">
              <tr>
                <td>{{em.material.title}}</td>
                <td>{{getUnitTitle(em.material.unitId)}}</td>
                <td>{{em.material.totalQuantity}}</td>
                <td class="emergency-material-quantity-input-col">
                  <input
                    [(ngModel)]="em.quantityUsed"
                    [ngModelOptions]="{standalone: true}"
                    class="form-control"
                    type="number"
                    min="0"
                    max="{{em.material.totalQuantity}}"
                  />
                </td>
                <td class="actionbuttn-refine">
                  <button class="grid-btn btn btn-success btn-sm material-btn"
                          ngbTooltip="Натиснете тук за да Запазите Промените."
                          placement="top" 
                          (click)="onSaveChanges(em, $event); materialsListSelect.selectedIndex = 0">
                    <i class="fa fa-check"></i>
                  </button>
                  <button class="grid-btn btn btn-danger btn-sm"
                          ngbTooltip="Натиснете тук за да редактирате материала."
                          placement="top"
                          (click)="onDeleteEmergencyMaterialClicked(em, $event); materialsListSelect.selectedIndex = 0">
                    <i class="fa fa-trash-o"></i>
                  </button>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
